import type { AxiosError } from "axios";

export function getChatApiErrorMessage(error: unknown, isArabic: boolean): string {
  if (error == null || typeof error !== "object") {
    return isArabic ? "تعذّر تحميل المحادثة، حاول مرة أخرى" : "Failed to load chat. Please try again.";
  }

  const err = error as AxiosError<{ message?: string }>;

  if (!err.response) {
    if (err.code === "ERR_NETWORK" || err.message === "Network Error") {
      return isArabic
        ? "خطأ في الشبكة. تأكد من الاتصال وعنوان واجهة البرمجة."
        : "Network error. Check your connection and API URL.";
    }
    return isArabic ? "تعذّر تحميل المحادثة، حاول مرة أخرى" : "Failed to load chat. Please try again.";
  }

  const status = err.response.status;
  const apiMessage = err.response.data?.message;

  if (status === 401) {
    return isArabic
      ? "انتهت الجلسة، برجاء تسجيل الدخول مرة أخرى"
      : "Session expired. Please login again.";
  }
  if (status === 403) {
    return isArabic
      ? "لا تملك صلاحية الوصول إلى هذه المحادثة"
      : "You do not have access to this chat.";
  }
  if (status === 404) {
    return isArabic ? "لم يتم العثور على الكورس" : "Course not found.";
  }
  if (status >= 500) {
    return isArabic ? "تعذّر تحميل المحادثة، حاول مرة أخرى" : "Failed to load chat. Please try again.";
  }

  if (typeof apiMessage === "string" && apiMessage.trim()) {
    return apiMessage;
  }

  return isArabic ? "تعذّر تحميل المحادثة، حاول مرة أخرى" : "Failed to load chat. Please try again.";
}
